import { render, staticRenderFns } from "./ComplementaryProductDescription.vue?vue&type=template&id=f83724e8&scoped=true&"
import script from "./ComplementaryProductDescription.vue?vue&type=script&lang=js&"
export * from "./ComplementaryProductDescription.vue?vue&type=script&lang=js&"
import style0 from "./ComplementaryProductDescription.vue?vue&type=style&index=0&id=f83724e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83724e8",
  null
  
)

export default component.exports